import { StaticImage } from 'gatsby-plugin-image';
import { Fragment } from 'react';

export const doctors = [
    {
        name: 'Shukan Kanuga, DDS, MSD',
        bio: () => {
            return (
                <Fragment>
                    <p>
                        Dr. Kanuga completed her Pediatric dentistry training with a MSD degree from
                        one of the most esteemed programs at the University of Washington, Seattle
                        in 2009. She was a dentist in India (GDCH, Ahmedabad) before she came to the
                        US in 2002. She received her DDS at the University of California, Los
                        Angeles (2006); and continued her training in hospital dentistry (2007). She
                        is a Diplomate of the American Board of Pediatric Dentistry.
                    </p>
                    <p>
                        With 10 years of training in Dentistry and several years of clinical
                        experience under her belt, Dr. Kanuga excels in managing and treating
                        children from 0 to 18 years of age; both typically developing and children
                        with special health care needs and disabilities. She provides comprehensive
                        dental treatment to children using non-pharmacologic as well as
                        pharmacologic behavior management techniques including Nitrous Oxide-
                        Oxygen, oral sedation and IV sedation with a dental anesthesiologist. Dr.
                        Kanuga prides herself in the practice of Evidence-based dentistry and an
                        emphasis on preventive oral care for young children.
                    </p>
                    <p>
                        Dr. Kanuga has served as an Editor at the San Fernando Valley Dental
                        Society, a board member of the California Society of Pediatric Dentistry and
                        an Evidence Reviewer for the American Dental Association. She has multiple
                        publications under her belt in esteemed journals including the Journal of
                        American Dental Association (JADA). She lectures internationally on various
                        topics in clinical pediatric dentistry and also presented at the AAPD annual
                        conference in May 2018. Dr. Kanuga and Dr. Hirano established their state of
                        the art fully digital pediatric dental practice, Kidz Dental Care in April
                        2018 in Santa Clarita, CA and the practice is well-renowned and sought after
                        in the community. She lives in suburban Los Angeles, CA with her husband and
                        her two children. In her leisure time, she enjoys cooking, reading, teaching
                        Zumba, spending time with her friends and family and traveling. With her
                        exceptional patient management skills and gentle demeanor, children and
                        parents love coming to Dr. Kanuga for their regular dental exam and
                        treatment.
                    </p>
                </Fragment>
            );
        },
        image: () => (
            <StaticImage
                className="image"
                src="./images/1-homepage/homepage-6-doctor.jpg"
                alt="Shukan Kanuga, DDS, MSD"
                quality={80}
            />
        ),
    },
    {
        name: 'Stephen F. Hirano, DDS',
        bio: () => {
            return (
                <Fragment>
                    <p>
                        I was born and raised in Honolulu, Hawaii and attended Punahou High School.
                        I later earned my Bachelor or Arts degree from the University of California,
                        Santa Barbara (UCSB) and continued to UCLA Dental School where I graduated
                        in 2002. I received my Pediatric specialty degree from the University of
                        Illinois, Chicago in 2004. In my spare time, I enjoy playing basketball,
                        baseball and golf. I also enjoy going to sporting events, wine tasting, and
                        spending time with my family, my three boys: Aiden, Kyle and Micah, and my
                        friends.
                    </p>
                </Fragment>
            );
        },
        image: () => (
            <StaticImage
                className="image"
                src="./images/2-doctors/hirano.jpg"
                alt="Stephen Hirano"
                quality={80}
            />
        ),
    },
    {
        name: 'Dr. Sederic Grant - SCV Office',
        bio: () => {
            return (
                <Fragment>
                    <p>
                        {`Dr. Grant grew up in Los Angeles, Ca. He completed his bachelor's in Public Health and Biology with a minor in Public Policy at UC Berkeley. He then completed dental school at UC San Francisco. He then went on to earn his speciality training in pediatric dentistry at the University of Minnesota. He received comprehensive experience and training in the treatment of children with complex medical concerns, use of sedative medications, and treatment of children in the operating room under general anesthesia. Dr. Grant is a Diplomate of the American Board of Pediatric Dentistry.`}
                    </p>
                    <p>
                        {`"I was inspired to become a pediatric dentist because of my traumatic experiences at the dental office at a young age. My family did not grow up with many financial resources and therefore, I did not seek out timely dental care as a child. As a pediatric dentist, I recognize that every child and family comes from different walks of life and has different experiences with the dentist. Therefore, I strive to give each child and family the most enjoyable experience and provide the level of care that I would give my own child or family member."`}
                    </p>
                    <p>
                        DDS Pediatric Dentistry Resident Department of Developmental and Surgical
                        Sciences University of Minnesota School of Dentistry
                    </p>
                </Fragment>
            );
        },
        image: () => (
            <StaticImage
                className="image"
                src="./images/2-doctors/grant.jpg"
                alt="Dr. Grant"
                quality={80}
            />
        ),
    },
    {
        name: ' Dr. Ryan Kim',
        bio: () => {
            return (
                <Fragment>
                    <p>
                        Dr. Ryan Kim earned his training in pediatric dentistry at Tufts University
                        School of Dental Medicine and his dental training at the Herman Ostrow
                        School of Dentistry of USC. He is currently an active member of the American
                        Board of Pediatric Dentistry. Dr. Ryan is passionate about creating positive
                        dental experiences that shape children’s lifelong oral health. Outside of
                        dentistry, Ryan enjoys golfing, exercising, and spending time with family.
                    </p>
                </Fragment>
            );
        },
        image: () => (
            <StaticImage
                className="image"
                src="./images/2-doctors/kim.jpg"
                alt="Dr. Ryan Kim"
                quality={80}
            />
        ),
    },
];
